import React, { Component } from 'react';
import { MenuItem, FontIcon, Divider, IconMenu, IconButton, Subheader } from 'material-ui';
import NavLink from '../nav-link';
import R from 'ramda';

class HoverableMenuItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleTouchTap = (event) => {
    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };
  render() {
    const { children, activeRoutes, routeName, subMenuItems, location, showSubMenu } = this.props;
    return (
      <div onClick={this.handleTouchTap}>
        <NavLink
          className="nav-link"
          activeRoutes={activeRoutes}
          location={location}
        >
          {children}
        </NavLink>
        {
          showSubMenu ? (
          <IconMenu
            open={this.state.open}
            iconButtonElement={<IconButton
              iconClassName={this.state.open ? 'tc-icon-arrow-drop-up' : 'tc-icon-arrow-drop-down'}
              iconStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
              style={{ padding: '12px 0px', width: '24px' }}
            />}
            anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
            targetOrigin={{ horizontal: 'left', vertical: 'top' }}
            onRequestChange={this.handleRequestClose}
          >
            {
              subMenuItems.map((menuItem, index) => {
                if (menuItem.type === 'divider') {
                  return <Divider key={index}/>;
                }
                if (menuItem.type === 'subheader') {
                  return <Subheader key={index}>{menuItem.text}</Subheader>;
                }
                return (
                  <MenuItem
                    desktop
                    key={index}
                    primaryText={menuItem.text}
                    onTouchTap={R.compose(
                      this.handleRequestClose,
                      menuItem.onTouchTap
                    )}
                    innerDivStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
                    leftIcon={typeof menuItem.icon === 'string' ?
                      <FontIcon className={menuItem.icon} color="rgba(0, 0, 0, 0.54)" />
                      : menuItem.icon
                    }
                  />
                );
              })
            }
          </IconMenu>) : <span/>
        }
      </div>
    );
  }
}

export default HoverableMenuItem;



// WEBPACK FOOTER //
// ./src/app/components/app-bar/hoverable-menu-item.jsx